import { combineReducers } from '@reduxjs/toolkit'

import { chosenCashierReducer } from './features/schedule/model/chosenSlice'
import { recentCashiersReducer } from './features/schedule/model/recentSlice'

/**
 * Состояние модуля `schedule`: только намерение человека — кассир, выбранный на экране «По кассирам», и последние выбранные
 * кассиры. Объекты, состав и назначения — в кэше запросов.
 */
export const scheduleUiReducer = combineReducers({ chosen: chosenCashierReducer, recent: recentCashiersReducer })
export type ScheduleUiState = ReturnType<typeof scheduleUiReducer>
